import coloData from "../../../../content/posts/data-release-notes/colo_2024.03/col_data.jsx";
import * as React from 'react';
export default {
  coloData,
  React
};